import type { StaffMember } from "src/types/settings";

const DetailRow = ({ label, value }: { label: string; value?: string }) => (
	<div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-b tw-border-border tw-py-2.5 last:tw-border-0">
		<span className="tw-text-[13px] tw-text-text-soft">{label}</span>
		<span className="tw-text-right tw-text-[13.5px] tw-font-medium tw-capitalize tw-text-text">{value || "—"}</span>
	</div>
);

interface StaffDetailsProps {
	staff: StaffMember;
}

const StaffDetails = ({ staff }: StaffDetailsProps) => (
	<div className="tw-flex tw-flex-col tw-gap-4">
		<div className="tw-rounded-[10px] tw-border tw-border-border tw-px-4">
			<DetailRow label="Storefront" value={staff?.store_or_warehouse} />
			<DetailRow label="Role" value={staff?.role} />
		</div>

		<div className="tw-rounded-[10px] tw-border tw-border-border tw-px-4">
			<DetailRow label="First name" value={staff?.first_name} />
			<DetailRow label="Last name" value={staff?.last_name} />
			<DetailRow label="Email address" value={staff?.email} />
			<DetailRow label="Phone number" value={staff?.phone} />
		</div>
	</div>
);

export default StaffDetails;
